function Terms() {
    return (
      <div style={{ width: "100vw", height: "100vh"}}>
        <iframe width="100%" height="100%" title="terms" src="https://docs.google.com/document/d/e/2PACX-1vSKM3mM-udzkJXtE76rxYfhnWcjvyFvHM4LdRXAWxBvxRHOo6jP4CnyXkx8MEA0q25eIqzKSdW_ixoY/pub?embedded=true"></iframe>
      </div>
    );
}
  
export default Terms;
  